import React from 'react';
import { Hero } from '@/components/ui/content-blocks';
import { useTranslation } from '@/hooks/useTranslation';

const HeroSection = () => {
  const { t } = useTranslation();
  
  return (
    <Hero
      title={t('aboutPage.hero.title')}
      subtitle={t('aboutPage.hero.subtitle')}
      description={t('aboutPage.hero.description')}
      details={t('aboutPage.hero.details')}
      backgroundClassName="bg-gradient-to-r from-blue-50 to-indigo-100"
      primaryCTA={{
        label: t('aboutPage.hero.primaryCTA'),
        href: "#contact"
      }}
      secondaryCTA={{
        label: t('aboutPage.hero.secondaryCTA'),
        href: "/references"
      }}
    />
  );
};

export default HeroSection; 